import { render, staticRenderFns } from "./SearchFilterGroupForm.vue?vue&type=template&id=804c3cdc"
import script from "./SearchFilterGroupForm.vue?vue&type=script&lang=js"
export * from "./SearchFilterGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports